import { useMemo, useEffect } from 'react';
import { useGetActionPlanAggregatedQuery } from '../../../hooks/queries/useDashboardPublicQueries';
import { ActionPlanStepService, type ActionPlanStepState } from '../logic/ActionPlanStepService';

export interface UseActionPlanStepParams {
  guid: string | undefined;
  isDirectActionPlanRoute: boolean;
}

export function useActionPlanStep({
  guid,
  isDirectActionPlanRoute,
}: UseActionPlanStepParams): ActionPlanStepState {
  const {
    data: aggregatedData,
    isLoading: isCheckingBackend,
  } = useGetActionPlanAggregatedQuery(guid!, {
    enabled: isDirectActionPlanRoute && Boolean(guid),
    retry: false,
  });

  const stepState = useMemo(() => {
    return ActionPlanStepService.determineStep({
      guid,
      isDirectActionPlanRoute,
      isCheckingBackend,
      hasAggregatedData: Boolean(aggregatedData),
    });
  }, [guid, isDirectActionPlanRoute, isCheckingBackend, aggregatedData]);

  useEffect(() => {
    if (!guid) return;

    const shouldSync = ActionPlanStepService.shouldSyncLocalStorage(
      Boolean(aggregatedData),
      stepState.hasSubmitted
    );

    if (shouldSync) {
      ActionPlanStepService.syncLocalStorage(guid);
    }
  }, [guid, aggregatedData, stepState.hasSubmitted]);

  return stepState;
}
